

import { Link } from "react-router-dom";


const CollectionCard = ({item, className}) => {
    
    return(
        <Link to = {`/collection/${item.name}`} 
            className={`card_animation auction_card flex flex-col items-center justify-center rounded-[10px] ${className}`}>
            <div className="image_box w-full h-full max-w-[800px] max-h-[800px] mb-3">
                <img src = {item.image} alt = {item.name} className = "w-full h-full object-cover image_content rounded-t-[10px]" />
            </div>

            <div className="flex flex-col w-full">
                <div className="flex justify-between items-center mb-3 pb-2 border-b-[1px] border-gray-600">
                    <h3 className="text-center text-base">{item.name}</h3>  
                    <p className="text-center text-base text-[#DE00FF]">{item.volume}</p>    
                </div>
                <div className="flex justify-between items-center">
                    <p className="text-center text-sm sm:text-base text-[#BCBCBC]">{item.creator}</p>  
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="text-red-500 w-[16px] h-[16px]" viewBox="0 0 512 512">
                        <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"/>
                    </svg>
                </div>
            </div>
            

        </Link>
    )
}

export default CollectionCard;